import React from 'react'
import { Ambulance, Printer, Smartphone, UserCheck } from 'lucide-react';

export default function () {
	const etapas = [
		{
			icon: <Smartphone size={28} />,
			title: "Cadastre suas informações",
			description: "Preencha seu histórico médico, medicamentos, alergias e contatos de emergência em nossa plataforma.",
			number: 1
		},
		{
			icon: <Printer size={28} />,
			title: "Imprima seu cartão",
			description: "Basta imprimir o cartão contendo o QRCode em qualquer impressora.",
			number: 2
		},
		{
			icon: <UserCheck size={28} />,
			title: "Leve sempre com você",
			description: "Mantenha o cartão sempre em sua carteira ou bolsa para qualquer eventualidade.",
			number: 3
		},
		{
			icon: <Ambulance size={28} />,
			title: "Acesso rápido em emergências",
			description: "Em caso de emergência, o profissional de saúde escaneia o QR Code e acessa seus dados médicos essenciais.",
			number: 4
		}
	];

	return (
		<section id="funcionamento" className="pb-20 pt-28 px-4 bg-gray-100">
			<div className="container mx-auto">
				<div className="text-center mb-16">
					<h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
						Como funciona o Prontuário da Saúde do Cidadão?
					</h2>
					<p className="text-lg text-gray-700 max-w-3xl mx-auto">
						Uma solução simples e eficaz para ter seus dados médicos sempre ao alcance
						em apenas quatro passos simples.
					</p>
				</div>

				<div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
					{etapas.map((etapa, index) => (
						<Etapa
							key={index}
							icon={etapa.icon}
							title={etapa.title}
							description={etapa.description}
							number={etapa.number}
						/>
					))}
				</div>
			</div>
		</section>
	)
}

function Etapa({ icon, title, description, number }) {
	return (
		<div className="flex flex-col md:flex-row items-center md:items-start gap-6">
			<div className="flex-shrink-0 w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center text-white">
				{icon}
			</div>

			<div className="flex-1 text-center md:text-left">
				<div className="text-sm font-medium text-gray-600 mb-1">Etapa {number}</div>
				<h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
				<p className="text-gray-700">{description}</p>
			</div>
		</div>
	)
}